import PrivacyPolicy from "./privacypolicy.js";

export default PrivacyPolicy;
